import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import api from "@/lib/api";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Marquee from "@/components/landing/Marquee";
import Services from "@/components/landing/Services";
import Packages from "@/components/landing/Packages";
import Fleet from "@/components/landing/Fleet";
import Estimator from "@/components/landing/Estimator";
import WhyUs from "@/components/landing/WhyUs";
import Testimonials from "@/components/landing/Testimonials";
import Footer from "@/components/landing/Footer";
import BookingModal from "@/components/BookingModal";
import PromoBanner from "@/components/PromoBanner";

export default function Landing() {
  const [lang, setLang] = useState("EN");
  const [bookingOpen, setBookingOpen] = useState(false);
  const [packages, setPackages] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    api.get("/packages").then((r) => setPackages(r.data)).catch(() => {});
    api.get("/vehicles").then((r) => setVehicles(r.data)).catch(() => {});
    api.get("/reviews").then((r) => setReviews(r.data)).catch(() => {});
  }, []);

  const openBooking = () => setBookingOpen(true);

  const avgRating = reviews.length
    ? Math.round((reviews.reduce((s, r) => s + (r.rating || 5), 0) / reviews.length) * 10) / 10
    : null;

  return (
    <>
      {avgRating && (
        <Helmet>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "TravelAgency",
              name: "Jay Jagannath Tour & Travels",
              url: "https://jayjagannathtravels.in/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: avgRating,
                reviewCount: reviews.length,
                bestRating: 5,
                worstRating: 1,
              },
            })}
          </script>
        </Helmet>
      )}
      <Navbar lang={lang} setLang={setLang} onBook={openBooking} />
      <PromoBanner />
      <main>
        <Hero lang={lang} onBook={openBooking} />
        <Marquee />
        <Services />
        <Packages packages={packages} />
        <Fleet vehicles={vehicles} />
        <Estimator />
        <WhyUs />
        <Testimonials reviews={reviews} packages={packages} />
      </main>
      <Footer onBook={openBooking} />
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} vehicles={vehicles} packages={packages} />
    </>
  );
}
